<form class="modal-background" bdFxLayoutAlign="center start" (ngSubmit)="onConfirmBtnClick()">


    <div class="projects-modal">
        <div class="header">
            <div class="title">
                {{ model.title }}
            </div>
        </div>

        <div class="content" >
            <div [innerHTML]="model.message"></div>
            <div [innerHTML]="model.createdAt | date:'dd.MM.yyyy'"></div>
        </div>



        <div class="footer">
            <button type="submit" class="btn btn-primary">Verstanden</button>
        </div>
    </div>
</form>
